export const FETCH_PICKUP_REQUEST = "FETCH_PICKUP_REQUEST";
export const FETCH_PICKUP_REQUSET_SUCCESS = "FETCH_PICKUP_REQUSET_SUCCESS";
export const FETCH_PICKUP_REQUEST_FAILURE  = "FETCH_PICKUP_REQUEST_FAILURE";
